const rankingItems = [
  { rank: 1, title: '最新院线动作巨制合集', type: '电影在线观看', hot: '本周最热', views: '58.3万' },
  { rank: 2, title: '热播电视剧每日追更专区', type: '电视剧免费', hot: '热度飙升', views: '47.6万' },
  { rank: 3, title: '高分悬疑推理片精选', type: '电影在线观看', hot: '口碑推荐', views: '42.1万' },
  { rank: 4, title: '爆笑喜剧电影大合集', type: '91电影视频', hot: '新上榜', views: '38.9万' },
  { rank: 5, title: '热门综艺爆笑名场面', type: '综艺节目', hot: '持续热门', views: '35.4万' },
  { rank: 6, title: '国产科幻大片全集', type: '最新影视', hot: '热门推荐', views: '31.7万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              天美麻花星空影视免费观看本周最受欢迎内容排行
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-50 transition-colors duration-200 cursor-pointer group"
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-600'
                }`}>
                  <span className="text-sm font-bold">{item.rank}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-400">{item.type}</span>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className={`px-2 py-0.5 text-xs rounded-full ${
                    item.hot.includes('飙升') ? 'bg-accent-100 text-accent-700' :
                    item.hot.includes('新上榜') ? 'bg-secondary-100 text-secondary-700' :
                    'bg-primary-50 text-primary-700'
                  }`}>
                    {item.hot}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.views}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}